<template>
  <div>
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="container">
      <div class="common-margin-top row">
        <div class="col col-12 col-md-6 col-lg-6  common-padding-top">
          <p class="common-letter-spacing common-line-height-2-5 common-padding-top">
            <span class="common-margin-left"></span>某创意商城，模式比较特殊，退款率比较高，非常容易触发风控系统。
            模式简要描述：100人付款买一件100元商品，系统抽取1位幸运者购买
            成功，其余99位无法购买成功，每人获得0.5元补偿金，支付款项原路
            退回。退款率99%导致无支付通道可用。
          </p>
        </div>
        <div class="col col-12 col-md-6 col-lg-6 text-top">
          <img class="common-margin-left my-col-8" :src="require('images/product/shop.png')" />
        </div>
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '创意商城',
        url: '#',
        describe: '这个场景我们仅提供支付服务，合作方自有系统，我们将模式与合作银行沟通，银行工作人员为其设置白名单，\n' +
          '因此，不再受高退款率风控限制。还提供了商户钱包，平台可以通过商户钱包及时发放补偿金。'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Cysc.vue